import { useState, useEffect, useContext } from "react";
import { AuthContext } from "context";
import crudsService from "services/cruds-service";
import productService from "services/product-service";

import MiniStatisticsCard from "e4acomponents/Cards/StatisticsCards/MiniStatisticsCard";
import CircularProgress  from "@mui/material/CircularProgress";
import Footer from "e4acomponents/Footer";
import DashboardLayout from "e4acomponents/LayoutContainers/DashboardLayout";
import DashboardNavbar from "e4acomponents/Navbars/DashboardNavbar";

import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";

import RecentChanges from "./components/RecentChanges";
import StockDiversity from "./components/StockDiversity";

export default function ClientsDashboard() {
    const [org, setOrg] = useState(null);
    const [totalProducts, setTotalProducts] = useState(0);
    const [totalProductValue, setTotalProductValue] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const authContext = useContext(AuthContext);

    useEffect(() => {
        (async () => {
            try {
                const userId = await authContext.getCurrentUser();
                const currentUser = await crudsService.getUser(userId);
                const org = currentUser.data.relationships.organizations?.data[0];

                // If the user has an organization, fetch product totals
                let productTotalRes;
                if (org) {
                    setOrg(org);
                    productTotalRes = await productService.getProductTotals(org.id);

                } else {
                    productTotalRes = await productService.getProductTotals();
                }

                const attributes = productTotalRes.data.attributes;
                setTotalProducts(attributes.totalProducts);
                setTotalProductValue(attributes.totalProductValue);
            } catch (error) {
                console.error("Error fetching dashboard data:", error);
            } finally {
                setIsLoading(false);
            }
        })();
    }, [])

    return (
        <DashboardLayout>
            {isLoading ? (
                <MDBox
                    width="100%"
                    height="100%"
                >
                    <CircularProgress />
                </MDBox>
            ) : (
                <>
                    <DashboardNavbar />
                    <MDBox py={3}><Grid container spacing={3}>
                        {/* Total Number of Products Statistic Card */}
                        <Grid item xs={12} md={6}>
                            <MiniStatisticsCard
                                title={{ text: "Total Number of Products" }}
                                count={totalProducts}
                                icon={{ color: "info", component: "inventory" }}
                            />
                        </Grid>
                        {/* Total Value of Products Statistic Card */}
                        <Grid item xs={12} md={6}>
                            <MiniStatisticsCard
                                title={{ text: "Total Value of Products" }}
                                count={`$${totalProductValue}`}
                                icon={{ color: "success", component: "attach_money" }}
                            />
                        </Grid>

                    </Grid>

                        <MDBox mt={6}>
                            <Grid container spacing={3}>

                                {/* Recent Changes */}
                                <Grid item xs={12} md={6}>
                                    <RecentChanges organization={org} />
                                </Grid>

                                {/* Stock Diversity */}
                                <Grid item xs={12} md={6}>
                                    <StockDiversity organization={org} />
                                </Grid>

                            </Grid>
                        </MDBox>
                        <MDBox mt={6}>
                            <Footer />
                        </MDBox>

                    </MDBox>
                </>)}
        </DashboardLayout>
    )
}